import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useCallback, useEffect } from "react";
import { NavItem, NavLink } from "reactstrap";
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from "../../util/Auth";

export const LoginItem = () => {
	const { instance, inProgress } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	
	useEffect(() => {
		if (!isAuthenticated || instance.getAllAccounts().length < 1) {
			return;
		}
		
		const account = instance.getAllAccounts()[0];

		instance.acquireTokenSilent({
			...loginRequest,
			account: account,
		}).then().catch((error) => {
			if (error instanceof InteractionRequiredAuthError) {
				instance.logoutRedirect({
					onRedirectNavigate: (url) => {
						// Return false if you would like to stop navigation after local logout
						return false;
					}
				});
			}
		});
	}, [instance, isAuthenticated]);
	
	const handleLogin = useCallback(() => {
		instance.loginRedirect(loginRequest);
	}, [instance]);

	const handleLogout = useCallback(() => {
		instance.logout();
	}, [instance]);

	return <NavItem>
		{isAuthenticated ?
			<NavLink style={{ cursor: "pointer" }} onClick={handleLogout} className="ccNavItem">Log Out</NavLink> :
			inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect ?
				<NavLink style={{ cursor: "pointer" }} onClick={handleLogin} className="ccNavItem">Log In</NavLink> : null}
	</NavItem>;
};
